module.exports = __webpack_public_path__ + "static/media/wh-rosette.418e0c59.webp";